import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class SendPaymentReminderResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "receiver": ["cobranzas@dundermifflin.com"],
            },
            errors: []
        }
    }
}
